module.exports = __webpack_public_path__ + "static/img/bgphone-title.64adb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bgphone-title.png
// module id = bsfz
// module chunks = 1